import { getSessions } from 'core/crud/sessions.crud';
import { useTranslate } from 'core/hooks/useTranslate';
import { useEffect, useState } from 'react';

function useDialogSelectSessions({ sessions, courseGuid, lessonGuid }) {
  const { t } = useTranslate();
  const [selectedSessions, setSelectedSessions] = useState([]);
  const [allSessions, setAllSessions] = useState([]);
  const [loadingSessions, setLoadingSessions] = useState(false);

  useEffect(() => {
    getData();
  }, []);

  function sanitizeData(response) {
    return response
      .map((item) => ({
        ...item,
        value: item.id,
        label: t('lesson:Session') + ' ' + item.order,
      }))
      .sort((a, b) => a.order - b.order);
  }

  async function getData() {
    setLoadingSessions(true);
    const response = await getSessions(courseGuid, lessonGuid);
    let data = [];
    if (response?.data?.data) {
      data = sanitizeData(response.data.data);
      setAllSessions(data);
      setSelectedSessions(data.filter((session) => sessions.map((s) => s.session_id).includes(session.id)));
      setLoadingSessions(false);
    } else {
      setLoadingSessions(false);
    }
  }

  function onChangeSelectedSessions(value) {
    setSelectedSessions(value);
  }

  return {
    t,
    loadingSessions,
    allSessions,
    selectedSessions,
    onChangeSelectedSessions,
  };
}

export default useDialogSelectSessions;
